import * as API_CONSTANT from "../constants";

export const getAllGroup = async() =>
    await fetch(`${API_CONSTANT.cnp_v1_fe_path}/group/get/all`, {
      method: "POST",
      headers: API_CONSTANT.headers,
      body: JSON.stringify({}),
    }).then((res) => res.json());

export const createGroup = ({coid, name, color}) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/group/create`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({coid, name, color}),
  }).then((res) => res.json());

export const updateGroup = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/group/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());
  
export const getGroupByCoID = (coid) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/group/get/coid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({coid}),
  }).then((res) => res.json());